import { __decorate, __metadata } from "tslib";
import { Component, Prop } from 'vue-property-decorator';
import BaseButton from '~/nasa_ui/base/BaseButton';
import { calculateTextColor, isValidColorValue, parseColorClasses } from '~/nasa_ui/utils/helpers/colors';
let ButtonGeneric = class ButtonGeneric extends BaseButton {
    loadingText;
    get computedColor() {
        if (!this.color) {
            return '--v-primary-base';
        }
        if (isValidColorValue(this.color)) {
            return this.color;
        }
        return parseColorClasses(this.color);
    }
    get computedHref() {
        if (!this.href && !this.to) {
            return null;
        }
        return this.to ? this.to.toString() : this.href;
    }
    get computedTextColor() {
        if (this.disabled) {
            return '#555';
        }
        if (!this.textColor) {
            return calculateTextColor(this.computedColor);
        }
        if (isValidColorValue(this.textColor)) {
            return this.textColor;
        }
        return parseColorClasses(this.textColor);
    }
    get hasIconSlot() {
        return this.hasSlot('icon');
    }
};
__decorate([
    Prop({
        default: 'Loading…',
        type: String
    }),
    __metadata("design:type", String)
], ButtonGeneric.prototype, "loadingText", void 0);
ButtonGeneric = __decorate([
    Component
], ButtonGeneric);
export default ButtonGeneric;
